import React, { memo, useMemo } from "react";
import { Box, MainText, PressableOpacity } from "app/components/common";
import { StyleSheet } from "react-native";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import theme from "app/Theme/Theme";
import { widthPercentageToDP } from "react-native-responsive-screen";
import FastImage from "react-native-fast-image";
import normalize from "app/utils/normalize";

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: 10,
    width: isWebDesktop ? "100%" : widthPercentageToDP("100%"),
    backgroundColor: theme.colors["neutral.white"],
  },
  image: {
    marginLeft: theme.spacing.xs,
    height: normalize(40),
    width: normalize(40),
    borderRadius: normalize(20),
  },
});

interface Props {
  handlePressResult: () => void;
  name: string;
  picture: string;
  index: number;
}

const UserNewMessageSearch = ({
  handlePressResult,
  index,
  picture,
  name,
}: Props) => {
  const source = useMemo(() => {
    return {
      uri: picture,
    };
  }, [picture]);

  const testID = useMemo(() => `search-message-hit${index}`, [index]);

  return (
    <PressableOpacity
      testID={testID}
      onPress={handlePressResult}
      style={styles.row}
    >
      <FastImage resizeMode="cover" style={styles.image} source={source} />
      <MainText
        variant="l4-semibold"
        marginLeft="xs"
        marginRight="xxs"
        numberOfLines={1}
      >
        {name}
      </MainText>
    </PressableOpacity>
  );
};

export default memo(UserNewMessageSearch);
